<template>
  <CCard>
    <CCardHeader>
      <strong style="line-height: 2.3">온실영상</strong>
      <div class="card-header-actions">
        <CButton
          type="button"
          size="sm"
          color="outline-primary"
          @click="showAddModal()"
        >
          <i class="fa fa-plus" aria-hidden="true"></i>
          추가
        </CButton>
      </div>
    </CCardHeader>
    <CCardBody>
      <CRow>
        <CCol col="12" v-if="videoList == null || videoList.length === 0">
          등록된 온실 영상 주소가 없습니다.
        </CCol>
        <CCol
          col="12"
          sm="6"
          xl="4"
          xxl="3"
          class="my-auto text-center"
          v-for="(video, index) in videoList"
          :key="index"
          @mouseover="video.showEdit = true"
          @mouseleave="video.showEdit = false"
        >
          <RealTimeVideo :src="app.getUrl(video.videoUrl)"></RealTimeVideo>
          <div
            class="position-absolute"
            style="top: 0; right: 10px"
            v-if="video.showEdit"
          >
            <CButton
              color="warning"
              size="sm"
              class="text-white scc-rounded"
              @click="editVideo(video)"
              ><i class="fa fa-edit" aria-hidden="true"></i
            ></CButton>
            <CButton
              color="danger"
              size="sm"
              class="scc-rounded ml-1"
              @click="deleteVideo(video)"
              ><i class="fa fa-trash" aria-hidden="true"></i
            ></CButton>
          </div>
        </CCol>
      </CRow>
    </CCardBody>
    <AddInEnvVideoModal
      v-if="modal.addEdit.visible"
      :properties="modal.addEdit"
    ></AddInEnvVideoModal>
  </CCard>
</template>

<script>
import RealTimeVideo from "@/components/RealTimeVideo";
import AddInEnvVideoModal from "@/modals/dashboard/AddEditInEnvVideoModal";
import FacilityVideoService from "@/services/facility/facility-video.service";
import store from "@/store";
import core from "@/core";

export default {
  name: "InEnvVideoCard",
  components: { AddInEnvVideoModal, RealTimeVideo },
  props: {
    src: "",
  },
  data() {
    return {
      app: store.state.app,
      videoList: [],
      modal: {
        addEdit: {
          visible: false,
          params: {
            type: "add",
            item: null,
          },
          watchClose: {
            result: "",
          },
        },
      },
    };
  },
  created() {
    this.imgSrc = this.src;
    this.reloadVideoList();
  },
  watch: {
    "app.facilityId"() {
      this.reloadVideoList();
    },
    "modal.addEdit.watchClose"() {
      const modal = this.modal.addEdit;
      if (modal.watchClose.result === "confirm") {
        this.reloadVideoList();
      }
    },
  },
  methods: {
    showAddModal() {
      const modal = this.modal.addEdit;
      modal.params.type = "add";
      modal.visible = true;
    },
    reloadVideoList() {
      this.videoList = [];

      FacilityVideoService.getList(this.app.facilityId).then((videoList) => {
        //console.log("videoList : ", videoList);
        videoList.forEach((video) => {
          video.showEdit = false;
        });
        this.videoList = videoList;
      });
    },
    editVideo(video) {
      const modal = this.modal.addEdit;
      modal.params.type = "edit";
      modal.params.item = video;
      modal.visible = true;
    },
    async deleteVideo(video) {
      const result = await core.alert.show({
        title: "확인",
        body: `영상을 삭제하시겠습니까?`,
        showCancelButton: true,
        cancelButtonText: "아니오",
        confirmButtonText: "예",
      });
      if (result === "confirm") {
        try {
          const apiResult = await FacilityVideoService.delete(
            this.app.facilityId,
            video.id,
          );
          this.reloadVideoList();
        } catch (e) {
          console.log(e);
        }
      }
    },
  },
};
</script>
